import { render } from "./PaymentLink.vue?vue&type=template&id=3a7ad282&scoped=true&ts=true"
import script from "./PaymentLink.vue?vue&type=script&lang=ts"
export * from "./PaymentLink.vue?vue&type=script&lang=ts"

import "./PaymentLink.vue?vue&type=style&index=0&id=3a7ad282&lang=css&scoped=true"

import exportComponent from "/codebuild/output/src1651641719/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a7ad282"]])

export default __exports__